// ─────────────────────────────────────────────────────────────
// PLACEHOLDER CONTACT DETAILS — these are only fallbacks.
// The admin Website Editor (/admin/edit) overrides them without code.
// ─────────────────────────────────────────────────────────────
export const WHATSAPP_NUMBER = "20000000000"; // digits only, international format (e.g. 201234567890)
export const WHATSAPP_DISPLAY = "+20 00 000 0000";
export const CONTACT_EMAIL = "hello@itminane.com";

// Link to your EXISTING attendance-platform login (separate website from this one).
export const LOGIN_URL = "https://login.itminane.com";

export const ORDER_MSG_EN = "Hello itminane! I'd like to order the attendance system for my school.";
export const ORDER_MSG_AR = "مرحبًا اطمئنان! أرغب بطلب نظام الحضور لمدرستي.";

// Default product imagery: 3D renders of the itminane terminal, served from public/images.
// Swap real photos in via the Website Editor (/admin/edit).
export const DEFAULT_IMAGES = {
  hero: "/images/hero.jpg",
  childTap: "/images/tap.jpg",
  gate: "/images/gate.jpg",
  card: "/images/card.jpg",
  gallery: [
    "/images/gallery-1.jpg",
    "/images/gallery-2.jpg",
    "/images/gallery-3.jpg",
    "/images/gallery-4.jpg",
  ],
};
